module.exports = __webpack_public_path__ + "static/media/2018_0718_18400600-01.f55908f0.jpg";